import SwitchWithText from 'components/atoms/switch/SwitchWithText';
import React, { useState } from 'react';
import dataService from 'services/dataService';
import { API_PATIENT_CCM_HOLDING_STATUS } from 'services/dataService/resources';
import { showResult } from 'utils';
import { useDispatch, useSelector } from 'react-redux';

const UpdateHoldingStatusCcm = () => {
  const { profile: patient } = useSelector(
    (state) => state.ccmPatientDetails.patient,
  );
  const {
    ccmPatientDetails: { setCcmHoldingStatus },
  } = useDispatch();
  const [loading, setLoading] = useState(false);

  const changeStatus = async (newStatus) => {
    const postData = {
      ccmHoldingStatus: newStatus,
      patientGuid: patient.guid,
    };
    setLoading(true);
    const { error, data } = await dataService.createOne(
      API_PATIENT_CCM_HOLDING_STATUS,
      postData,
    );
    setLoading(false);
    if (data) {
      setCcmHoldingStatus({
        ccmHoldingStatus: data.ccmHoldingStatus,
        ccmHoldingStatusStartDate: data.ccmHoldingStatusStartDate,
      });
    }
    if (error) {
      showResult(error);
    }
  };

  return (
    <div className="ccm-holding-status-update-form">
      <hr />
      <div className="holding-status-popup__field-title">Temporary Hold</div>
      <div className="ccm-holding-status-update-form__switch-wrapper">
        <SwitchWithText
          checked={patient.ccmHoldingStatus}
          onChange={changeStatus}
          loading={loading}
        />
        {patient.ccmHoldingStatusStartDate && (
          <span>From {patient.ccmHoldingStatusStartDate}</span>
        )}
      </div>
    </div>
  );
};

export default UpdateHoldingStatusCcm;
